import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Knak Case Study | Canny';
const Description =
  "Read about how Knak's customer success team uses Canny to streamline feedback processes.";
const Image = 'https://canny.io/images/26e1cdee70dc5f876a06ce1339eec4b5.jpg';

export default class KnakLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/knak' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
